import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { Container, Row,  Spinner } from 'reactstrap';
import { IGlobalContextProps, withGlobalContext } from 'src/context/global.context';
import { IProject, IProposition } from 'src/model';
import { listMyProjects, listMyPropositions } from 'src/services';
import { ProjectList } from '../Payment/PaymentProjectList';
import { PropositionList } from '../Payment/PaymentPropositiontList';



interface IPaymentstate {
  loaded: boolean;
  projectList: IProject[];
  propositionList: IProposition[];
}

class Payment extends React.Component<
  IGlobalContextProps & RouteComponentProps,
  IPaymentstate
> {
  public state = {
    loaded: false,
    projectList: [] as IProject[],
    propositionList: [] as IProposition[],
  };


  public async componentDidMount() {
    try {
      const propositionList = await listMyPropositions();
      if (propositionList) {
        this.setState({ propositionList });
      }
      const projectList = await listMyProjects();
      if (projectList) {
        this.setState({
          projectList: projectList.filter(
            (project: IProject) => project.meta.status !== 'hidden'
          ),
        });
      }
    } catch {
      this.setState({ loaded: true });
    }
    this.setState({ loaded: true });
  }

  public render() {
    const { loaded, propositionList, projectList } = this.state;
    const { user } = this.props.context;
    // const newPropositionList = propositionList.filter(
    //   (proposition: IProposition) =>
    //     user && user.type === 'consultant'
    //       ? proposition.meta.status === 'hidden'
    //       : proposition.meta.status === 'validated'
    // ); 
     const endedProjectsFilter = (project: IProject) =>
       project.meta.status === 'ended';
     const otherProjectsFilter = (project: IProject) =>
      project.meta.status !== 'ended' && project.meta.status !== 'canceled' ;

   

    const endedPropositionsFilter = (proposition: IProposition) =>
     // proposition.meta.status === 'refused' ||
     // proposition.meta.status === 'expired' ||
      (proposition.meta.status === 'accepted' &&
        proposition.project.meta.status === 'ended');
    const otherPropositionsFilter = (proposition: IProposition) =>
      proposition.meta.status !== 'refused' &&
      proposition.meta.status !== 'rejected' &&
      proposition.meta.status !== 'expired' &&
      (proposition.meta.status !== 'accepted' ||
        proposition.project.meta.status !== 'ended');

        return !loaded ? (
          <Container
            className='d-flex flex-column justify-content-around align-items-center'
            style={{ minHeight: 'calc(100% - 180px)' }}
          >
            <div className='d-flex flex-column align-items-center'>
              <Spinner type='grow' color='primary' />
              <span className='mt-3'>Chargement...</span>
            </div>
          </Container>
        ) : (
          <Container style={{ minHeight: 'calc(100% - 145px)' }}>
            {projectList.length || propositionList.length ? (
              <Container className='pt-4'>
                {user && user.type === 'client' ? (
                  <> 
                    <ProjectList
                      label='Projets en cours'
                      filter={otherProjectsFilter}
                      projectList={projectList}
                      propositionList={propositionList}
                      src='agile-process'
                    />
                    <ProjectList
                      label='Projets terminés'
                      filter={endedProjectsFilter}
                      projectList={projectList}
                      propositionList={propositionList}
                      src='finished'
                    />
                  </>
                ) : (
                  <>  
                    <PropositionList
                      label='Projets en cours'
                      propositionFilter={otherPropositionsFilter}
                      propositionList={propositionList}
                      src='agile-process'
                    />
                    <PropositionList
                      label='Projets terminés'
                      propositionFilter={endedPropositionsFilter}
                      propositionList={propositionList}
                      src='finished'
                    />
                  </>
                )}
              </Container>
            ) : (
              user &&
              loaded && (
                
                <Row className ='d-flex align-items-center  justify-content-center mt-5'>
                <h2 className='text-primary'>
                Aucun projet en cours
               </h2>
              </Row>
             
              )
            )}
          </Container>
        );
      }
    }
    
    export const PaymentWithGlobalContext = withGlobalContext(
      withRouter(Payment)
    );
    


// WEBPACK FOOTER //
// ./src/components/Payment/Payment.tsx